import { httpClient } from '@/shared/lib/http-client';
import { API_ENDPOINTS } from '@/shared/config/api';

/** Фото ленты «О клинике» на главной. */
export interface GalleryImage {
  id: number;
  imageUrl: string;
  width: number;
  height: number;
  sortOrder: number;
  createdAt: string;
  updatedAt: string;
}

export interface GalleryListResponse {
  success: boolean;
  images: GalleryImage[];
}

export interface GalleryImageResponse {
  success: boolean;
  image: GalleryImage;
}

/**
 * Одно фото после сжатия в браузере — до 2–3 МБ; на медленной связи это
 * дольше общего таймаута клиента (10 с).
 */
const UPLOAD_TIMEOUT_MS = 120_000;

export const galleryApi = {
  async list(): Promise<GalleryListResponse> {
    const response = await httpClient.get<GalleryListResponse>(API_ENDPOINTS.GALLERY.LIST);
    return response.data;
  },

  async upload(
    file: File,
    onProgress?: (event: { loaded: number; total?: number }) => void
  ): Promise<GalleryImageResponse> {
    const response = await httpClient.uploadFile<GalleryImageResponse>(
      API_ENDPOINTS.GALLERY.UPLOAD,
      file,
      'image',
      onProgress,
      UPLOAD_TIMEOUT_MS
    );
    return response.data;
  },

  async remove(id: number): Promise<void> {
    await httpClient.delete(API_ENDPOINTS.GALLERY.DELETE(id));
  },

  async updateSortOrder(
    updates: Array<{ id: number; sortOrder: number }>
  ): Promise<GalleryListResponse> {
    const response = await httpClient.patch<GalleryListResponse>(
      API_ENDPOINTS.GALLERY.UPDATE_SORT_ORDER,
      { updates }
    );
    return response.data;
  }
};
